var map = {
	"./ADA.svg": [
		1325,
		1325
	],
	"./AMZN.svg": [
		7066,
		7066
	],
	"./APPL.svg": [
		679,
		679
	],
	"./AUD.svg": [
		4671,
		4671
	],
	"./AUS.svg": [
		834,
		834
	],
	"./AXS.svg": [
		5726,
		5726
	],
	"./BTC.svg": [
		1719,
		1927
	],
	"./CAC.svg": [
		8778,
		8778
	],
	"./CAD.svg": [
		5870,
		5870
	],
	"./CHF.svg": [
		8650,
		8650
	],
	"./CL.svg": [
		522,
		522
	],
	"./CNH.svg": [
		4852,
		4852
	],
	"./CZK.svg": [
		7646,
		7646
	],
	"./DASH.svg": [
		4076,
		4076
	],
	"./DAX.svg": [
		9831,
		9831
	],
	"./DKK.svg": [
		751,
		751
	],
	"./DOGE.svg": [
		2154,
		2154
	],
	"./DOT.svg": [
		1177,
		1177
	],
	"./EOS.svg": [
		876,
		876
	],
	"./ESP.svg": [
		3385,
		3385
	],
	"./ETF.svg": [
		8142,
		8142
	],
	"./ETH.svg": [
		3753,
		3753
	],
	"./EUR.svg": [
		4888,
		4888
	],
	"./FRA.svg": [
		6638,
		6638
	],
	"./FTSE.svg": [
		6852,
		6852
	],
	"./FUT.svg": [
		2394,
		2394
	],
	"./GALA.svg": [
		8493,
		8493
	],
	"./GBP.svg": [
		2353,
		2353
	],
	"./GBR.svg": [
		797,
		797
	],
	"./GER.svg": [
		603,
		603
	],
	"./HKD.svg": [
		7313,
		7313
	],
	"./HKG.svg": [
		6011,
		6011
	],
	"./HUF.svg": [
		7880,
		7880
	],
	"./IOTA.svg": [
		5116,
		5116
	],
	"./JPY.svg": [
		6337,
		6337
	],
	"./LTC.svg": [
		7062,
		7062
	],
	"./MANA.svg": [
		7225,
		7225
	],
	"./MXN.svg": [
		7975,
		7975
	],
	"./NAS.svg": [
		6305,
		6305
	],
	"./NEO.svg": [
		7098,
		7098
	],
	"./NOK.svg": [
		9695,
		9695
	],
	"./NZD.svg": [
		8747,
		8747
	],
	"./OMG.svg": [
		8536,
		8536
	],
	"./PLN.svg": [
		4581,
		4581
	],
	"./PYG.svg": [
		9296,
		9296
	],
	"./QTUM.svg": [
		4745,
		4745
	],
	"./SEK.svg": [
		8193,
		8193
	],
	"./SGD.svg": [
		7764,
		7764
	],
	"./SOL.svg": [
		1708,
		1708
	],
	"./SPX.svg": [
		9326,
		9326
	],
	"./TRX.svg": [
		9939,
		9939
	],
	"./TRY.svg": [
		4389,
		4389
	],
	"./TSLA.svg": [
		3442,
		1855
	],
	"./US.svg": [
		2836,
		2836
	],
	"./USD.svg": [
		2350,
		1773
	],
	"./USOIL.svg": [
		8246,
		8246
	],
	"./XAG.svg": [
		5205,
		5205
	],
	"./XAU.svg": [
		8451,
		8451
	],
	"./XLM.svg": [
		3958,
		2878
	],
	"./XMR.svg": [
		6648,
		6648
	],
	"./XPT.svg": [
		1086,
		1086
	],
	"./XRP.svg": [
		947,
		4154
	],
	"./ZAR.svg": [
		3663,
		3663
	],
	"./ZEC.svg": [
		2913,
		2913
	],
	"./default.svg": [
		5250,
		5250
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7211;
module.exports = webpackAsyncContext;